import { render } from "./cargo.vue?vue&type=template&id=d22e6a1a"
import script from "./cargo.vue?vue&type=script&lang=js"
export * from "./cargo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__